/** Valores alineados con `facturas.metodo_pago` / `paymentMethodTypeToFacturaDb`. */
export const METODOS_PAGO_REGISTRO_COBRANZA: { value: string; label: string }[] = [
  { value: 'EFECTIVO', label: 'Efectivo' },
  { value: 'TRANSFERENCIA', label: 'Cuenta bancaria' },
  { value: 'NEQUI', label: 'Nequi' },
  { value: 'DAVIPLATA', label: 'Daviplata' },
  { value: 'TARJETA', label: 'Tarjeta' },
  { value: 'OTRO', label: 'Otro' },
];

/** Prefer the company's configured methods; fall back to the fixed list. */
export function opcionesMetodoPagoRegistro(
  methods: Array<{ method_name?: string | null; method_type?: string | null }>
): { value: string; label: string }[] {
  const seen = new Set<string>();
  const fromConfig: { value: string; label: string }[] = [];
  for (const m of methods) {
    const label = String(m.method_name || '').trim() || String(m.method_type || '').trim();
    if (!label) continue;
    const value = label;
    if (seen.has(value.toLowerCase())) continue;
    seen.add(value.toLowerCase());
    fromConfig.push({ value, label });
  }
  return fromConfig.length > 0 ? fromConfig : METODOS_PAGO_REGISTRO_COBRANZA;
}
